// const _ = require('lodash');
// const pluralize = require('pluralize')
import { plural } from 'pluralize';

import _includes from 'lodash/includes';
import _split from 'lodash/split';
import _isUndefined from 'lodash/isUndefined';
import _capitalize from 'lodash/capitalize';
import { getServerTranslator } from './serverI18n';

// const splitUrlToParts = function (url) {
//   if (!url || typeof url !== "string") {
//     return []; // return empty array if url is null/undefined/not a string
//   }
//   return url.split("/").filter(Boolean);
// };
// const splitUrlToParts = function (url) {
//   return url.split('/');
// };
const splitUrlToParts = function (url) {
  if (!url || typeof url !== 'string') return [];
  return url.split('/');
};

/**
 * Extract age slug from a full URL or raw slug.
 * "/net-worth/women/63-years-old" → "63-years-old"
 * "63-years-old" → "63-years-old"
 */
function extractAgeSlug(urlOrSlug) {
  if (!urlOrSlug || typeof urlOrSlug !== 'string') return '';
  const parts = urlOrSlug.split('/');
  return parts.length > 3 ? parts[3] : parts[0];
}

/**
 * Parse an age slug into structured data.
 * Pure logic — no i18n dependency. Exported for testing.
 */
export function parseAgeSlug(slug) {
  if (!slug || typeof slug !== 'string') return { years: 0, months: 0, weeks: 0 };
  const parts = slug.split('-');
  if (parts.includes('years') && (parts.includes('months') || parts.includes('month'))) {
    return { years: parseInt(parts[0]) || 0, months: parseInt(parts[2]) || 0, weeks: 0 };
  }
  if (parts.includes('week'))  return { years: 0, months: 0, weeks: parseInt(parts[0]) || 0 };
  if (parts.includes('month')) return { years: 0, months: parseInt(parts[0]) || 0, weeks: 0 };
  if (parts.includes('year') || parts.includes('years'))
    return { years: parseInt(parts[0]) || 0, months: 0, weeks: 0 };
  return { years: 0, months: 0, weeks: 0 };
}

/**
 * Format age as a standalone noun phrase: "63 years old", "1 year old".
 * ICU plural handles singular/plural correctly per locale.
 */
const getAgeDesc = function (url, locale = 'en-US') {
  const slug = extractAgeSlug(url);
  if (!slug) return '';
  const { years, months, weeks } = parseAgeSlug(slug);
  const { t } = getServerTranslator(locale);

  if (years > 0 && months > 0) return t('ageDesc.yearsAndMonthsOld', { years, months });
  if (weeks > 0)               return t('ageDesc.weeksOld', { weeks });
  if (months > 0)              return t('ageDesc.monthsOld', { months });
  if (years > 0)               return t('ageDesc.yearsOld', { years });
  return '';
};

/**
 * Format age as a compound adjective: "63 year old", "1 year old".
 * Always singular time unit in en-US (compound modifier rule).
 * Translators use their own grammar rules per locale.
 */
export const getAgeDescAdjective = function (url, locale = 'en-US') {
  const slug = extractAgeSlug(url);
  if (!slug) return '';
  const { years, months, weeks } = parseAgeSlug(slug);
  const { t } = getServerTranslator(locale);

  if (years > 0 && months > 0) return t('ageDesc.yearsAndMonthsOldAdj', { years, months });
  if (weeks > 0)               return t('ageDesc.weeksOldAdj', { weeks });
  if (months > 0)              return t('ageDesc.monthsOldAdj', { months });
  if (years > 0)               return t('ageDesc.yearsOldAdj', { years });
  return '';
};

// const getLMBlurb = function(){
//     return 'NettleWorth has a range of charts and calculators that measure the body, mind and human experience from birth to beyond.';
// };

/**
 * Maps an age (number) to a lifeStage i18n key suffix.
 * Pure logic — no i18n dependency.
 */
export function ageToLifeStageKey(age) {
  if (age >= 85) return 'seniors';
  if (age >= 75) return 'seniors';
  if (age >= 65) return 'retirees';
  if (age >= 55) return 'lateMiddleAgedAdults';
  if (age >= 45) return 'middleAgedAdults';
  if (age >= 35) return 'professionalAdults';
  if (age >= 25) return 'youngProfessionals';
  if (age >= 20) return 'youngAdults';
  if (age >= 13) return 'teenager';
  if (age > 4) return 'child';
  if (age === 4) return 'preschooler';
  if (age >= 1) return 'toddler';
  return 'baby';
}

const getLifeStage = function (url, locale = 'en-US') {
  var age_array = _split(splitUrlToParts(url)[3], '-');
  var key = '';
  var temp = 0;

  if (_includes(age_array, 'years') && (_includes(age_array, 'months') || _includes(age_array, 'month'))) {
    temp = parseInt(age_array[0]);
    key = ageToLifeStageKey(temp);
  } else if (_includes(age_array, 'week')) {
    key = 'baby';
  } else if (_includes(age_array, 'month')) {
    temp = parseInt(age_array[0]);
    if (temp >= 4 && temp <= 11) {
      key = 'baby';
    } else if (temp >= 13 && temp <= 35) {
      key = 'toddler';
    }
  } else if (_includes(age_array, 'year') || _includes(age_array, 'years')) {
    temp = parseInt(age_array[0]);
    key = ageToLifeStageKey(temp);
  }

  if (!key) return '';
  const { t } = getServerTranslator(locale);
  return t(`lifeStage.${key}`);
};

// const getChartType = function (url) {
//   var url_fragment = _split(splitUrlToParts(url)[1], '-')[0];
//   var chart_type = '';

//   if (!_isUndefined(url_fragment)) {
//     if (url_fragment === 'bmi') {
//       url_fragment = _upperCase(url_fragment);
//     } else {
//       url_fragment = _capitalize(url_fragment);
//     }
//     chart_type = url_fragment;
//   } else {
//     chart_type = 'weight';
//   }

//   return chart_type;
// };

// TODO // CODE TO REMOVE ABOVE
/**
 * Maps a URL slug (e.g. "net-worth") to a chartType i18n key suffix.
 */
export function urlSlugToChartTypeKey(slug) {
  switch (slug) {
    case 'net-worth': return 'netWorth';
    case 'annual-income': return 'annualIncome';
    case 'retirement-fund': return 'retirementFund';
    default: return null;
  }
}

const getChartType = function (url, locale = 'en-US') {
  const parts = splitUrlToParts(url);
  let url_fragment = parts[1]; // e.g. "net-worth", "annual-income", "retirement-fund"

  if (!_isUndefined(url_fragment) && url_fragment) {
    const key = urlSlugToChartTypeKey(url_fragment);
    if (key) {
      const { t } = getServerTranslator(locale);
      return t(`chartType.${key}`);
    }
    // Fallback for unknown slugs: capitalize as before
    return url_fragment
      .split('-')
      .map((w) => _capitalize(w))
      .join(' ');
  }

  const { t } = getServerTranslator(locale);
  return t('chartType.netWorth');
};

// function parseAgeFromUrl(url) {
//   const ageRegex = /(\d+)(?:-years)?(?:-(\d+)-months)?(?:-(\d+)-weeks)?-old/i;
//   const genderMatch = url.includes('/boys/') ? 'Boy' : url.includes('/girls/') ? 'Girl' : 'Baby';
//   const match = url.match(ageRegex);

//   if (!match) {
//     return { number: 0, type: 'Month', gender: genderMatch };
//   }

//   const years = parseInt(match[1] || '0', 10);
//   const months = parseInt(match[2] || '0', 10);
//   const weeks = parseInt(match[3] || '0', 10);

//   if (weeks > 0 && years === 0 && months === 0) {
//     return { number: weeks, type: 'week', gender: genderMatch };
//   }

//   const totalMonths = years * 12 + months;

//   return {
//     number: totalMonths,
//     type: 'Month',
//     gender: totalMonths < 24 ? 'Baby' : genderMatch,
//   };
// }
function parseAgeFromUrl(url) {
  // --- 🛡️ Defensive check
  if (!url || typeof url !== 'string') {
    return { number: 0, type: 'year', gender: 'household' };
  }

  // --- Determine gender
  let gender = 'household';
  if (url.includes('/men/')) gender = 'men';
  else if (url.includes('/women/')) gender = 'women';
  else if (url.includes('/household/')) gender = 'household';

  // --- Match /30-years-old or /30-year-old
  const ageRegex = /\/(\d+)(?:-years-old|-year-old)?/i;
  const match = url.match(ageRegex);

  if (!match) {
    return { number: 0, type: 'year', gender };
  }

  const years = parseInt(match[1], 10);

  // --- Validate range
  if (isNaN(years) || years < 15 || years > 100) {
    return { number: 0, type: 'year', gender };
  }

  return { number: years, type: 'year', gender };
}

const getGender = function (url, ageInMonths = false) {
  var url_fragment = splitUrlToParts(url)[2];
  var gender = '';

  switch (url_fragment) {
    case 'men':
      gender = 'men';
      break;
    case 'women':
      gender = 'women';
      break;
    case 'household':
      gender = 'household';
      break;
    default:
      gender = 'men';
      break;
  }
  return gender;
};

export const getPageH1Title = function (url, locale = 'en-US') {
  const { t } = getServerTranslator(locale);
  const gender = getGender(url);
  const chartType = getChartType(url, locale);
  const lifeStage = plural(getLifeStage(url, locale));

  return t('titleDescription.h1', { gender, chartType, lifeStage });
};

export const getPageDataH1Title = function (url, locale = 'en-US') {
  const { t } = getServerTranslator(locale);
  const gender = getGender(url);
  const chartType = getChartType(url, locale);

  return t('titleDescription.dataH1', { gender, chartType });
};

export const getPageDataH1SubTitle = function (url, locale = 'en-US') {
  const { t } = getServerTranslator(locale);
  const lifeStage = plural(getLifeStage(url, locale));
  const ageDesc = getAgeDesc(url, locale);

  return t('titleDescription.dataH1Sub', { lifeStage, ageDesc });
};

const getPageH2Title = function (url, locale = 'en-US') {
  const { t } = getServerTranslator(locale);
  const gender = getGender(url);
  const chartType = getChartType(url, locale);
  const ageDesc = getAgeDesc(url, locale);

  return t('titleDescription.h2', { gender, chartType, ageDesc });
};

export const getPageH1SubTitle = function (url, locale = 'en-US') {
  return getAgeDesc(url, locale);
};

const returnPageVariableHash = function (url, locale = 'en-US') {
  return {
    pageH1Title: getPageH1Title(url, locale),
    pageH1SubTitle: getPageH1SubTitle(url, locale),
    pageH2Title: getPageH2Title(url, locale),
    pageDataH1Title: getPageDataH1Title(url, locale),
    pageDataH1SubTitle: getPageDataH1SubTitle(url, locale),
  };
};

export { returnPageVariableHash, getAgeDesc, getLifeStage };
